import { render, staticRenderFns } from "./purchase-amount.vue?vue&type=template&id=017dd4fd&scoped=true&"
import script from "./purchase-amount.vue?vue&type=script&lang=js&"
export * from "./purchase-amount.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount.vue?vue&type=style&index=0&id=017dd4fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017dd4fd",
  null
  
)

export default component.exports